/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Ticket } from '../../models/ticket';
import { TicketCreate } from '../../models/ticket-create';

export interface ApiTicketPost$Params {
      body: TicketCreate
}

export function apiTicketPost(http: HttpClient, rootUrl: string, params: ApiTicketPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Ticket>> {
  const rb = new RequestBuilder(rootUrl, apiTicketPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Ticket>;
    })
  );
}

apiTicketPost.PATH = '/api/ticket';
